<div class="auth-layout-container">
  <div class="auth-wrapper">
    
    <div class="auth-form-panel">
      <ng-content></ng-content>
    </div>

    <div class="auth-image-panel">
      <img src="assets/images/login-image.png" alt="Authentication Image" />
    </div>

  </div>
  <umkt-footer variant="auth" class="auth-footer"></umkt-footer>
  <umkt-footer variant="default"></umkt-footer>
</div>
